import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import AddressFields from '@/components/common/AddressFields.vue';
import { Address, defaultAddress } from '@/models/info.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressField',
  props: {
  modelValue: {
    type: Object as PropType<Address>,
    required: true,
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const address = ref<Address>({ ...props.modelValue });

const emit = __emit;

function update(v: Address) {
  emit('update:modelValue', {
    ...v,
    alternative: [...(address.value.alternative || [])],
  });
  emit('change', {
    ...v,
    alternative: [...(address.value.alternative || [])],
  });
}

watch(
  () => props.modelValue,
  () => {
    address.value = { ...props.modelValue };
  },
);

function updateAlternative(v: Address, index: number) {
  const alternative = [...(address.value.alternative || [])];
  alternative.splice(index, 1, v);

  Object.assign(address.value, {
    ...address.value,
    alternative,
  });

  update(address.value);
}

function addAdress() {
  Object.assign(address.value, {
    ...address.value,
    alternative: [...(address.value.alternative || []), { ...defaultAddress }],
  });
}

function removeAddress(index: number) {
  const alternative = [...(address.value.alternative || [])];
  alternative.splice(index, 1);

  Object.assign(address.value, {
    ...address.value,
    alternative,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('initiative.edit.addresses', {
        count: 1 + (address.value.alternative?.length || 0),
      })), 1),
    _createVNode(AddressFields, {
      modelValue: address.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
        update
      ],
      disabled: __props.disabled
    }, null, 8, ["modelValue", "disabled"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(address.value.alternative || [], (a, index) => {
      return (_openBlock(), _createBlock(AddressFields, {
        label: `Alternative ${index + 1}`,
        removable: "",
        onRemove: ($event: any) => (removeAddress(index)),
        key: index,
        disabled: __props.disabled,
        modelValue: (address.value.alternative || [])[index],
        "onUpdate:modelValue": [($event: any) => (((address.value.alternative || [])[index]) = $event), (v) => updateAlternative(v, index)]
      }, null, 8, ["label", "onRemove", "disabled", "modelValue", "onUpdate:modelValue"]))
    }), 128)),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          onClick: addAdress
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.addAddress')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
  ], 64))
}
}

})